import AltLinkMissing from './advices/AltLinkMissing'
import LabelMissing from './advices/LabelMissing'
import ContrastError from './advices/ContrastError'
import HeadingPossible from './advices/HeadingPossible'
import LinkSuspicious from './advices/LinkSuspicious'
import LinkRedundant from './advices/LinkRedundant'
import Noscript from './advices/Noscript'
import TitleRedundant from './advices/TitleRedundant'
import Aria from './advices/Aria'
import AriaLabel from './advices/AriaLabel'
import AriaTabindex from './advices/AriaTabindex'
import AriaLiveRegion from './advices/AriaLiveRegion'
import AriaHidden from './advices/AriaHidden'
import AltNull from './advices/AltNull'
import AltLink from './advices/AltLink'
import Figure from './advices/Figure'
import Label from './advices/Label'
import LinkSkip from './advices/LinkSkip'
import LinkSkipTarget from './advices/LinkSkipTarget'
import Lang from './advices/Lang'
import BrokenSkipLink from './advices/BrokenSkipLink'
import AltSuspicious from './advices/AltSuspicious'
import LabelMultiple from './advices/LabelMultiple'
import HeadingEmpty from './advices/HeadingEmpty'
import AltRedundant from './advices/AltRedundant'
import ImageTitle from './advices/ImageTitle'
import RegionMissing from './advices/RegionMissing'
import HeadingSkipped from './advices/HeadingSkipped'
import LinkPdf from './advices/LinkPdf'
import TextSmall from './advices/TextSmall'
import Alt from './advices/Alt'
import Underline from './advices/Underline'

function RenderCategoryItemAdvice(props) {
  const { itemId } = props

  switch (itemId) {
    case 'alt':
      return <Alt />
    case 'underline':
      return <Underline />
    case 'alt_link_missing':
      return <AltLinkMissing />
    case 'link_skip_broken':
      return <BrokenSkipLink />
    case "label_missing":
      return <LabelMissing />
    case "label_multiple":
      return <LabelMultiple />
    case "heading_empty":
      return <HeadingEmpty />
    case "alt_suspicious":
      return <AltSuspicious />
    case "link_pdf":
      return <LinkPdf />
    case "text_small":
      return <TextSmall />
    case "alt_redundant":
      return <AltRedundant />
    case "image_title":
      return <ImageTitle />
    case "region_missing":
      return <RegionMissing />
    case "heading_skipped":
      return <HeadingSkipped />
    case 'contrast':
      return <ContrastError />
    case "heading_possible":
      return <HeadingPossible />
    case "link_suspicious":
      return <LinkSuspicious />
    case "link_redundant":
      return <LinkRedundant />
    case "noscript":
      return <Noscript />
    case "title_redundant":
      return <TitleRedundant />
    case "alt_null":
      return <AltNull />
    case "alt_link":
      return <AltLink />
    case "figure":
      return <Figure />
    case "label":
      return <Label />
    case "link_skip":
      return <LinkSkip />
    case "link_skip_target":
      return <LinkSkipTarget />
    case "lang":
      return <Lang />
    case "aria":
      return <Aria />
    case "aria_label":
      return <AriaLabel />
    case "aria_tabindex":
      return <AriaTabindex />
    case "aria_live_region":
      return <AriaLiveRegion />
    case "aria_hidden":
      return <AriaHidden />
    default:
      return ''
  }
}
export default RenderCategoryItemAdvice